
  // document.querySelectorAll('.accordion-header').forEach(header => {
  //   header.style.cursor = 'pointer'; // Optional styling

  //   header.addEventListener('click', () => {
  //     const content = header.nextElementSibling;

  //     // Toggle display
  //     if (content.style.display === 'block') {
  //       content.style.display = 'none';
  //     } else {
  //       content.style.display = 'block';
  //     }
  //   });
  // });

  // // Optional: initially hide all content
  // document.querySelectorAll('.accordion-content').forEach(c => c.style.display = 'none');

  //Custom accordian
   const accordion = document.getElementById("custom-accordion");
  const headings = accordion.querySelectorAll("h2");

  headings.forEach((heading, i) => {
    // add icon span by JS
    const icon = document.createElement("span");
    icon.className = "icon";
    icon.textContent = "+";
    heading.appendChild(icon);

    heading.addEventListener("click", () => {
      // hide all others
      headings.forEach((h, j) => {
        const ic = h.querySelector(".icon");
        if (i !== j) {
          let sib = h.nextElementSibling;
          while (sib && sib.tagName !== "H2") {
            sib.style.display = "none";
            sib = sib.nextElementSibling;
          }
          ic.textContent = "+";
        }
      });

      // toggle this
      let sib = heading.nextElementSibling;
      let isOpen = sib && sib.style.display === "block";
      while (sib && sib.tagName !== "H2") {
        sib.style.display = isOpen ? "none" : "block";
        sib = sib.nextElementSibling;
      }
      icon.textContent = isOpen ? "+" : "−";
    });

    // initialize hidden
    let sib = heading.nextElementSibling;
    while (sib && sib.tagName !== "H2") {
      sib.style.display = "none";
      sib = sib.nextElementSibling;
    }
  });